"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOBILE_APP_ICON_WIDTH = exports.MOBILE_APP_ICON_HEIGHT = exports.MOBILE_APP_ICON_GIF_OR_SVG = exports.MOBILE_APP_ICON = void 0;
const MOBILE_APP_ICON_HEIGHT = exports.MOBILE_APP_ICON_HEIGHT = 35;
const MOBILE_APP_ICON_WIDTH = exports.MOBILE_APP_ICON_WIDTH = 35;
const MOBILE_APP_ICON_GIF_OR_SVG = exports.MOBILE_APP_ICON_GIF_OR_SVG = 'mobile-app-icon-gif-or-svg';
const MOBILE_APP_ICON = exports.MOBILE_APP_ICON = 'mobile-app-icon';
